import '../../styles/pages_app/store-map.scss';

import '../util/map-store-locator';
import '../vendor/infobubble';


function DataSource() {
    $.extend(this, new storeLocator.StaticDataFeed());
    this.setStores(this.parse_(ROLI.storesData));
}

DataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
    new storeLocator.Feature('grand', 'Seaboard GRAND'),
    new storeLocator.Feature('rise', 'Seaboard RISE'),
    new storeLocator.Feature('blocks', 'BLOCKS'),
    new storeLocator.Feature('songmakerkit', 'Songmaker Kit')
);

DataSource.prototype.getFeatures = function() {
    return this.FEATURES_;
};
DataSource.prototype.parse_ = function(json) {
    var stores = [];

    for (var i = 0; i < json.length; i++) {
      var row = json[i];

      if (!row['online_only']) {

          var features = new storeLocator.FeatureSet();
          var products = row.products_sold || [];
          for (var j = 0; j < products.length; j++) {
              features.add(this.FEATURES_.getById(products[j]));
          }

          var position = new google.maps.LatLng(row.lat, row.lng);

          var store = new storeLocator.Store(i, position, features, row);
          stores.push(store);
      }

  }
  return stores;
};

// Check connection to google works
if (google && google.maps) {

    // var ICON = new google.maps.MarkerImage(
    //     '../public/assets/img/store-finder/roli-icon.png?x=y',
    //     null,
    //     null,
    //     new google.maps.Point(0, 0)
    //   );
    google.maps.event.addDomListener(window, 'load', function() {
        $('body').addClass('loading');
        (ROLI.storesData) ? initMap() : document.addEventListener('loadStoresComplete', initMap, false);
    });
}
else {
    $('$js-map-load-error').show();
}

function initMap() {
    $('body').removeClass('loading');

    var lat, lng;
    var reg = /\?lat=(-*\d+.*\d*)&lng=(-*\d+.*\d*)/i;
    var latlng = window.location.href.match(reg);
    var LocationInQuery = (latlng)

    if (LocationInQuery) {
        lat = latlng[1];
        lng = latlng[2];
    }
    else {
        //use defualt map center
        lat = 43.767492;
        lng = -36.203631;
    }

    var map = new google.maps.Map(document.getElementById('map-canvas'), {
        center: new google.maps.LatLng(lat, lng),
        zoom: LocationInQuery ? 10 : 3,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false
    });

    var panelDiv = document.getElementById('map-panel');

    var data = new DataSource();

    var view = new storeLocator.View(map, data, {
        geolocation: LocationInQuery ? false : true,
        features: data.getFeatures()
    });

    view.createMarker = function(store) {
        var markerOptions = {
                position: store.getLocation(),
                // icon: ICON,
                title: store.getDetails().name
            };
        return new google.maps.Marker(markerOptions);
    };

    var infoBubble = new InfoBubble({
        backgroundClassName: 'storefinder-panel store-infowindow ',
        backgroundColor:
            $('.js-infowindow-bg-setter').css('backgroundColor'),
        shadowStyle: 0,
        padding: 0,
        borderRadius: 0,
        borderWidth: 0,
        disableAutoPan: true,
        hideCloseButton: true,
        arrowPosition: 30,
        arrowSize: 10,
        arrowStyle: 0
    });

    view.getInfoWindow = function(store) {
        if (store) {
            var details = store.getDetails();
            var hours = (details.hours) ? details.hours.join('<br>') : '';
            var html = [
                    '<div style="padding: 20px 20px 5px 20px;">',
                    '<h4 class="store-infowindow__title">',
                        '<a target="_blank" href="', details.website, '">',
                            details.name,
                        '</a>',
                    '</h4>',
                    '<p>', details.phone, '</p>',
                    '<p>', details.address, '</p>',
                    '<p>', hours, '</p>',
                    store.generateFeaturesHTML_(),
                    '</div>'
                ].join('');
            infoBubble.setContent($(html)[0]);
        }
        return infoBubble;
    };

    new storeLocator.Panel(panelDiv, {
      view: view
    });
}




/** WEBPACK FOOTER **
 ** ./app/assets/scripts/pages/store-map.js
 **/